import { FilterButtonItem } from '../types';

export function sortButtonItems<T>(
    items: FilterButtonItem<T>[],
    orderBy: 'priority' | 'alphabetical' | 'none' | 'both',
): FilterButtonItem<T>[] {
    if (orderBy === 'priority') {
        return [...items].sort((a, b) => {
            if (!a.priority) return 1;
            if (!b.priority) return -1;
            return a.priority - b.priority;
        });
    }

    if (orderBy === 'alphabetical') {
        return [...items].sort((a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1));
    }

    if (orderBy === 'both') {
        const alphaSortedItems = sortButtonItems(items, 'alphabetical');
        return sortButtonItems(alphaSortedItems, 'priority');
    }

    return items;
}
